import { render, staticRenderFns } from "./get-in-touch.vue?vue&type=template&id=67308ecc&"
import script from "./get-in-touch.vue?vue&type=script&lang=js&"
export * from "./get-in-touch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports